import React from 'react';
import { IdentificationIcon } from '@heroicons/react/24/outline';
import PassportTypeBack from './PassportTypeBack';
import { makeCardRecord } from '@bilt/domain/cardRecord';
import type { PassportCard } from '../../services/api/passportCards';
import { collectorFacts } from '@bilt/domain/collectorTemplate';
import '../home/build-stat-card.css';

export default function PassportRecordBack({
  card,
  demo,
  compact = false,
}: {
  card: PassportCard;
  demo: boolean;
  active: boolean;
  loadBuildDetails?: boolean;
  compact?: boolean;
}) {
  const record = makeCardRecord(card, demo);
  if (compact) return <PassportTypeBack card={card} demo={demo} compact />;
  return (
    <>
      <PassportTypeBack card={card} demo={demo} />
      {card.subject && (
        <section className="pc-record-facts">
          <h3>Front of card</h3>
          <dl>
            {collectorFacts(card.subject_type, 'front', card.subject.facts).map((f) => (
              <div key={f.key}>
                <dt>{f.label}</dt>
                <dd>{f.value}</dd>
              </div>
            ))}
          </dl>
        </section>
      )}
      <div className="bs-card pc-record-appendix">
        {record.edition && (
          <div className="pc-record-edition">
            <IdentificationIcon aria-hidden="true" />
            <div>
              <span className="bs-label">Edition record</span>
              <strong>{record.edition}</strong>
            </div>
          </div>
        )}
        {record.story &&
          !(
            card.subject_type === 'commemorative' &&
            record.story === String(card.subject?.facts?.story || card.design.story || '').trim()
          ) && (
            <section className="pc-record-story">
              <span className="bs-label">Behind the card</span>
              <p>{record.story}</p>
            </section>
          )}
        <p className="bs-provenance">
          <span>{record.issuer}</span>
          <span>{record.state}</span>
        </p>
      </div>
    </>
  );
}
